import { DefaultNotification } from "../default-notification/classes";
import { EMailAudit } from "../mail/classes";

export class DefaultMail {
    mailid: string = null;
    mailreceiver: string[] = [];
    maildefaultnotification: string = null;
    transactionid: string = null;
    defaultnotification: DefaultNotification = null;
}
export class Issue {
    issueid: number = null;
    issuecreator: string = null;
    issuecreation: string = null;
    issuecustomer: number = null;
    issuepriority: number = null;
    issuecategory: number = null;
    issuedesc: string = null;
    issuestate: number = null;
    issuetitle: string = null;
    folderlocation: string = null;
    issueescalation: string = null;
    issuenumber: number = null;
    issuetype: number = null;
    changetype: number = null;
    commercialcontactpersonalid: number = null;
    localcontactpersonalid: number = null;
    issuenote: string = null;
    anchestors: undefined | number[] = [];
    followers: undefined | number[] = [];
    laststatuschange: string = null;
    concurrencystamp: string = null;
    filesexported: boolean = false;
}

export class IssueCategory {
    categoryid: number;
    categoryname: string;
    categorycolor: string;
    categorydesc: string;
    ischangecategory: boolean;
    isincidentcategory: boolean;
    isissuecategory: boolean;
    isprojectcategory: boolean;
}

export class IssuePriority {
    priorityid: number;
    prioritydesc: string;
    prioritycolor: string;
    prioritycode: string;
    priorityname: string;
    ischangepriority: boolean;
    isincidentpriority: boolean;
    isissuepriority: boolean;
    isprojectpriority: boolean;
}

export class IssueStatus {
    stateid: number;
    statename: string;
    statecolor: string;
    statecode: string;
    stateescalationdays: number;
    isvtstate: boolean;
    iscpstate: boolean;
    ischangestate: boolean;
    isincidentstate: boolean;
    isissuestate: boolean;
    isprojectstate: boolean;
    isfinalstatus: boolean;
    aspNetRoleIds: number[];
}

export class IssueItem {
    itemid: number = null;
    itemname: string = null;
    itemcontract: number = null;
    itemcount: number = 1;
    itemproduct: number = null;
    itemdesc: string = null;
    iteminfo: string = null;
    itemposition: number = null;
    itemlocation: number = null;
    itemsetupcost: number = null;
    itemrentalcost: number = null;
    itempurchasecost: number = null;
    itemissue: number = null;
    itemfaktdate: string = null;
    itembuildindate: string = null;
    itemcanceldate: string = null;
    issueitemcontractitemtransformation: [] = [];
    issue: Issue = null;
}

export class IssueTransaction {
    guid: string = null;
    name: string = null;
    result: number = null;
    icon: string = null;
    color: string = null;
}

export class IssueTransactionAttribute {
    id: number;
    name: string;
}

export class DownloadFilesTask {
    download: string[] = [];
}

export class TransformIssueItemTask {
    item: number;
    contract: number;
}

export class UploadFileTask {
    data: FormData = new FormData();
}

export class TransformIssueItemsDialogComponentOutputData {
    map: IssueItemContractMap[];
}

export class IssueItemContractMap {
    item: number;
    contract: number;
}

export class IssueAuditWrapper {
    created: string;
    eMailAudit: EMailAudit[];
    guid: string;
    issueIdentifier: number;
    issueFileAudit: IssueFileAudit[];
    issueItemStatus: IssueItemAuditStatus[];
    issueStatus: IssueAuditStatus[];
    issueTransactionAudit: IssueTransactionAudit[] = [];
    issueUserAssignments: UserIssueConnectionAudit[];
    recordEnd: string;
    userId: string;
    specialAction: number;
    running: boolean;
}

export class IssueAuditStatus extends Issue {
    anchestor: IssueAuditStatus;
    anchestorFor: IssueAuditStatus[];
    anchestorId: string;
    guid: string;
    issueAuditWrapperId: string;
    note: string;
}

export class IssueFileAudit {
    action: number;
    destination: string;
    guid: string;
    issueAuditWrapperId: string;
    nextcloudHref: string;
}

export class UserIssueConnectionAudit {
    guid: string;
    isAssigned: boolean;
    isNew: boolean;
    isWatched: boolean;
    issueAuditWrapperId: string;
    issueId: number;
    note: string;
    userId: string;
}

export class IssueItemAuditStatus extends IssueItem {
    anchestor: IssueItemAuditStatus;
    anchestorFor: IssueItemAuditStatus[];
    anchestorId: string;
    guid: string;
    issueAuditWrapperId: string;
    note: string;
}

export class IssueTransactionAudit {
    auditNote: string;
    dateTime: string;
    guid: string;
    issueAuditWrapperId: string;
    transactionIdentifier: number;
}
